/* eslint-disable no-template-curly-in-string */
import yup, { canItems } from 'schemas/validation/feature'
import { isNil } from 'ramda'

import { isNumber } from 'utils/types'
import { OPERATORS_REQUIRING_HYSTERESIS } from 'constants/conditions'
import { COMPLEX } from 'utils/constants'

import signalSchema from './signalSchema'
import { requiredCan } from './utils'

const hysteresisSchema = yup
  .number()
  .nullable()
  .when(
    ['signal', 'subType', 'operator', 'parentType'],
    (ctxSignal, subType, operator, parentType, schema) =>
      (ctxSignal || subType) &&
      OPERATORS_REQUIRING_HYSTERESIS.has(operator) &&
      parentType === COMPLEX
        ? yup.number().required().inInputRange(ctxSignal, subType)
        : schema
  )
  .when(['$minValue', '$maxValue'], (minValue, maxValue, schema) =>
    isNumber(minValue) && isNumber(maxValue)
      ? yup.number().required().min(minValue).max(maxValue).nullable()
      : schema
  )

const conditionSchema = yup.object({
  ...canItems,
  queryType: yup.string(),
  parentType: yup.string().nullable(),
  subType: yup.string(),
  operator: yup.number(),
  inputConfig: yup.string(),
  value: yup
    .mixed()
    .required()
    .when(['signal', 'subType'], (ctxSignal, subType, schema) =>
      ctxSignal || subType
        ? yup.number().required().inInputRange(ctxSignal, subType)
        : schema
    )
    .when(['$minValue', '$maxValue'], (minValue, maxValue, schema) =>
      isNumber(minValue) && isNumber(maxValue)
        ? yup.number().required().min(minValue).max(maxValue).nullable()
        : schema
    ),
  canId: yup.string().nullable().when(['queryType', 'description'], {
    is: requiredCan,
    then: yup.string().required(),
  }),
  numberOfBits: yup
    .number()
    .nullable()
    .when('canId', {
      is: (id) => !isNil(id),
      then: yup.number().required(),
    }),
  startBit: yup
    .number()
    .nullable()
    .when('canId', {
      is: (id) => !isNil(id),
      then: yup.number().required(),
    }),
  parentQueryUri: yup.string().nullable(),
  signal: signalSchema,
  hysteresis: hysteresisSchema,
  floatingCircuit: yup.string().nullable(),
})

export default conditionSchema
